module.exports = __webpack_public_path__ + "static/media/SmoothPanda_Toilettenpapier_800x500.91d83789.jpg";